// ANGULAR
import { Injectable } from '@angular/core';

// NGRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

// RXJS
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';

// SERVICES
import { UserService } from '../services/user.service';

// ACTIONS AND STATES
import * as globalActions from '../../../global/store/actions';
import { State } from '../../../root-state';
import * as userActions from './actions';

// COMMON INTERFACES AND ENUMS
import { ModalType } from '../../../../models/common/modal/modal-config';

// CONSTANT


/**
 * This effect is for listen user actions, execute user service call and dispatch in user reducer.
 * For user api call purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 28-05-2020(Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created user effect
 */
@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private userService: UserService) { }

    /**
			* User Effect
			* @param type : User action name.
			* @param payload : object to identify common user method base on module and method.
			* @returns Empty action dispatch to reducer.
			*/
  userCommonEffect$ = createEffect(() => this.actions$.pipe(
    ofType<userActions.UserCommonAction>(userActions.ActionTypes.USER_COMMON),
    withLatestFrom(this.store),
    mergeMap(([action, state]): Observable<any> => {
      // get common constant base action module and method.
      // changed to payload type from payload.data.method
      const common: any = '';

      // avoid service call if data already exists in store.
      if (state[common.STATE]) {
        return of(new globalActions.EmptyAction({}));
      }
      // Only sending payload data

      return this.userService[common.API_METHOD](action.payload.data)
        .pipe(

          mergeMap((data: any) => {
            // throwing an error on if the status is not 200
         
            let actions: any[] = [];


            // dispatch user success action
            actions = [new userActions.UserCommonSuccessAction({ data, common })];

            if (common.SUCCESS_NOTIFICATION) {
              // dispatch popup notification for open success popup
              actions.push(new globalActions.PopupNotificationAction({
                actionType: userActions.ActionTypes.USER_COMMON, type: ModalType.SUCCESS,
                callback: action.payload.callback, title: common.TITLE, message: common.SUCCESS,
                code: `${common.SUCCESS}`, response: data,
              }));
            } else {
              action.payload.callback && action.payload.callback({ success: true, data });
            }

            return actions;
          }),
          catchError(error => {
            console.log(error);
            // dispatch popup notification for open error popup
            return of(new globalActions.PopupNotificationAction({
              actionType: userActions.ActionTypes.USER_COMMON_SUCCESS, type: ModalType.ERROR,
              message: error && error.error && error.error.message, callback: action.payload.callback, error: (error || error.error),
              // code: `ERROR.${error.code || error.error.code}`,
              title: common.TITLE,
            }));
          },
          ));
    }),
  ));

}
